import AgreementPageLayout from './AgreementPageLayout.component';

export default AgreementPageLayout;
